import React, { useState } from "react";
import Profile from "../components/Profile/Profile";
import Aside from "../modules/SideNav/Aside";

function ProfileLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <Profile handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
}

export default ProfileLayout;
